import React, { useContext } from 'react';
import { ReactComponent as PackageIcon } from '../../../assets/icon/Package.svg';
import { CompanyContext } from '../../../context/CompanyContext';
import { Colors } from '../../../VentoryUI/util/color.util';

export default function LoadingPackage({ color }: { color?: string }) {
  const { currentCompany } = useContext(CompanyContext);
  return (
    <PackageIcon
      width={100}
      height={100}
      opacity={0.6}
      strokeWidth={1}
      className='animate-bounce'
      fill={color || Colors.getPrimaryColor(currentCompany)}
    />
  );
}
